import React, { FC } from 'react';
import MuiAccordionDetails, { AccordionDetailsProps as MuiAccordionDetailsProps } from '@mui/material/AccordionDetails';
import { BpDesignSystem } from '../../types';
import { styled } from '../../styles';

export type AccordionDetailsProps = BpDesignSystem.PropsWithChildren<MuiAccordionDetailsProps>;

export const AccordionDetails: FC<AccordionDetailsProps> = ({ dataTest = 'accordion-details', ...props }) => (
  <StyledAccordionDetails data-test={dataTest} {...props} role="tabpanel" />
);

export const StyledAccordionDetails = styled(MuiAccordionDetails)`
  display: flex;
  flex-direction: column;
  && {
    padding: 0 1rem 1rem 1rem;
  }
`;
